if (!customElements.get('blog-filters')) {

  class BlogFilters extends HTMLElement {

    constructor() {
      super();
      this.blogUrl = this.dataset.blogUrl;
      this.radios = this.querySelectorAll('.radio-custom');
      this.activeContainers = this.querySelectorAll('.active-filters');
    }

    connectedCallback() {
      if (!this.blogUrl || !this.radios.length) return;
      this.bindEvents();
      this.restoreFromUrl();
    }

    bindEvents() {
      this.radios.forEach(radio => {
        radio.addEventListener('change', () => {
          this.syncGroupAcrossInstances(radio);
          this.applyFilters();
        });
      });
    }

    syncGroupAcrossInstances(changedRadio) {
      const group = changedRadio.dataset.filterGroup;
      if (!group) return;

      document.querySelectorAll(`blog-filters .radio-custom[data-filter-group="${group}"]`).forEach(radio => {
        if (radio !== changedRadio) {
          radio.checked = false;
        }
      });
    }

    applyFilters() {
      const allRadios = document.querySelectorAll('blog-filters .radio-custom:checked');
      const selected = [...new Set(Array.from(allRadios).map(r => r.value))];
      if (!selected.length) {
        window.location.href = this.blogUrl;
        return;
      }
      const tagPath = selected.join('+');
      window.location.href = `${this.blogUrl}/tagged/${tagPath}`;
    }

    restoreFromUrl() {
      const currentTags = window.location.pathname.split('/tagged/')[1];
      const activeTags = currentTags ? currentTags.split('+') : [];
      this.radios.forEach(radio => {
        radio.checked = activeTags.includes(radio.value);
      });
      this.renderActiveFilters();
    }

    renderActiveFilters() {
      const checkedRadios = document.querySelectorAll('blog-filters .radio-custom:checked');
      const uniqueValues = [...new Set(Array.from(checkedRadios).map(r => r.value))];
      const selectedRadios = uniqueValues.map(value =>
        Array.from(checkedRadios).find(r => r.value === value)
      );
      this.activeContainers.forEach(container => {
        container.innerHTML = '';
        selectedRadios.forEach(radio => {
          const labelText = radio.closest('.item')?.querySelector('.radio-custom-label .txt')?.textContent.trim() || radio.value;
          const chip = document.createElement('button');
          chip.className = 'badge flex align-items-center';
          chip.type = 'button';
          chip.innerHTML = `${labelText} <svg aria-hidden="true" role="presentation" class="icon icon-close" viewBox="0 0 32 32"><path class="stroke" d="M4.2,4.2,27.8,27.8m-23.6,0L27.8,4.2"></path></svg>`;
          chip.addEventListener('click', () => {
            document.querySelectorAll(`blog-filters .radio-custom[value="${radio.value}"]`).forEach(r => r.checked = false);
            this.applyFilters();
          });
          container.appendChild(chip);
        });
        container.style.display = selectedRadios.length ? '' : 'none';
      });
    }
  }
  customElements.define('blog-filters', BlogFilters);
}


if(!customElements.get('blog-filters-mobile')) {
  class BlogFiltersMobile extends HTMLElement {
    constructor() {
      super();
      this.buttonOpen = document.querySelector('.page-hero .open-filters');
      this.buttonClose = this.querySelector('.close');
      this.onKeyDown = this.handleKeyDown.bind(this);
      this.onClick = this.handleOnClick.bind(this);
      this.buttonOpen.addEventListener('click', this.open.bind(this));
      this.buttonClose.addEventListener('click', this.close.bind(this));
    }

    open() {
      if(!this.isOpen()) {
        $s.showOverlay();
        this.classList.add('open');
        setTimeout(()=>{
          $s.trapFocus(this)
          document.addEventListener('keydown', this.onKeyDown);
          document.addEventListener('click', this.onClick);
          window.addEventListener('mediaChange', this.onMediaChange);
        }, 100);
      }
    }

    close() {
      $s.removeTrapFocus();
      $s.hideOverlay();
      this.classList.remove('open');
      document.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('click', this.onClick);
    }

    isOpen() {
      return this.classList.contains('open');
    }

    handleKeyDown(e) {
      if (e.which == 27) { //Exit
        if(this.isOpen()){
          e.preventDefault();
          this.close();
          return false;
        }
      }
    }

    handleOnClick(e) {
      if(!this.contains(e.target)) {
        this.close();
      }
    }

  }
  customElements.define('blog-filters-mobile', BlogFiltersMobile);
}